
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const BrandPartners: React.FC = () => {
  const residentialBrands = [
    { name: "GAF:", description: "Master Elite contractor with access to complete product lines" },
    { name: "Owens Corning:", description: "Preferred contractor for Duration and TruDefinition systems" },
    { name: "CertainTeed:", description: "SELECT ShingleMaster certified installer" },
    { name: "Atlas:", description: "Pinnacle Contractor certification for premium products" },
    { name: "Malarkey:", description: "Certified installer for Legacy and Windsor systems" }
  ];

  const commercialBrands = [
    { name: "Firestone:", description: "Authorized contractor for EPDM and TPO systems" },
    { name: "GAF Commercial:", description: "Certified for all membrane and modified systems" },
    { name: "Johns Manville:", description: "Peak Advantage contractor status" },
    { name: "Carlisle SynTec:", description: "Authorized applicator for single-ply systems" },
    { name: "IB Roof Systems:", description: "Certified installer for PVC and TPO products" }
  ];

  const specialtyBrands = [
    { name: "Tremco:", description: "Certified applicator for fluid-applied systems" },
    { name: "Gaco:", description: "Factory-trained installer for silicone coating systems" },
    { name: "Ames Research:", description: "Certified for advanced liquid membrane products" },
    { name: "DECRA:", description: "Authorized installer for stone-coated steel products" },
    { name: "Duro-Last:", description: "Certified contractor for PVC membrane systems" }
  ];

  return (
    <section className="mb-12">
      <h2 className="text-3xl font-bold mb-6">Our Trusted Brand Partners</h2>
      <p className="text-lg mb-6">
        We work exclusively with industry-leading manufacturers to ensure the highest quality installations:
      </p>

      <div className="grid md:grid-cols-2 gap-6 mb-8">
        <Card>
          <CardHeader>
            <CardTitle className="text-xl">Residential Shingle Partners:</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2">
              {residentialBrands.map((brand, index) => (
                <li key={index}>• <strong>{brand.name}</strong> {brand.description}</li>
              ))}
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-xl">Commercial Roofing Partners:</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2">
              {commercialBrands.map((brand, index) => (
                <li key={index}>• <strong>{brand.name}</strong> {brand.description}</li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Specialty Product Partners:</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-2 gap-4">
            <ul className="space-y-2">
              {specialtyBrands.slice(0, 3).map((brand, index) => (
                <li key={index}>• <strong>{brand.name}</strong> {brand.description}</li>
              ))}
            </ul>
            <ul className="space-y-2">
              {specialtyBrands.slice(3).map((brand, index) => (
                <li key={index}>• <strong>{brand.name}</strong> {brand.description}</li>
              ))}
            </ul>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default BrandPartners;
